var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"活动参与人员","visible":true,"width":"95%","top":"2vh","before-close":function () { return _vm.$emit('remove'); }}},[_c('table-render',{ref:"tableRender",attrs:{"config":_vm.config,"height":"60vh","prop-data":{
      query: {
        serviceActivityId: _vm.serviceActivityId
      }
    },"rowClassName":function (ref) {
            var row = ref.row;
            var rowIndex = ref.rowIndex;

            return _vm.getUnqualifiedRowConfig({
          row: row,
          rowIndex: rowIndex,
          isNotUnqualified: _vm.isNotUnqualified(row)
        });
},"pageLayout":"total, sizes, prev, pager, next, jumper"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }